import React, { useState } from "react";
import { api } from "../api";
import { toast } from "./Toast";

// BudgetingNoticeGate: a budgeting-only person (free app use, no advice; see
// backend services/client_relationship.is_budgeting_only) acknowledges once
// that the app is budgeting software, not advice. POST /auth/me/budgeting-notice
// records when, plus the exact text shown. Pass-through for everyone else.

export default function BudgetingNoticeGate({ user, children }: { user: any; children: React.ReactNode }) {
  const needsNotice = user?.role === "client" && !!user?.budgeting_only && !user?.budgeting_notice_accepted_at;
  const [accepted, setAccepted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  if (!needsNotice || accepted) return <>{children}</>;

  const accept = async () => {
    setSubmitting(true);
    try {
      await api.post("/auth/me/budgeting-notice", {});
      setAccepted(true);
    } catch {
      toast.error("Couldn't save that. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{ position: "fixed", inset: 0, background: "#F5F3EE", zIndex: 4000, overflowY: "auto", padding: "40px 20px" }}>
      <div style={{ maxWidth: "520px", margin: "0 auto", background: "white", border: "1px solid #E5E7EB", borderRadius: "4px", padding: "24px" }}>
        <div style={{ fontSize: "12px", fontWeight: 800, color: "var(--brand-primary)", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: "6px" }}>
          Before you begin
        </div>
        <h1 style={{ margin: "0 0 10px", fontSize: "22px", fontWeight: 800, color: "#111827", letterSpacing: "-0.02em" }}>
          Welcome to your budget
        </h1>
        <p style={{ margin: "0 0 20px", fontSize: "14px", color: "#374151", lineHeight: 1.6 }}>
          This is budgeting software. It isn't financial advice, and using it doesn't make you an advisory client.
        </p>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <button
            onClick={accept}
            disabled={submitting}
            style={{
              padding: "11px 22px", borderRadius: "4px", border: "none", fontSize: "14px", fontWeight: 700, fontFamily: "inherit",
              background: "var(--brand-primary)", color: "white",
              cursor: submitting ? "not-allowed" : "pointer", opacity: submitting ? 0.5 : 1,
            }}
          >{submitting ? "Saving…" : "Got it"}</button>
        </div>
      </div>
    </div>
  );
}
